<template>
  <CDropdown
    placement="bottom-end"
    class="c-header-nav-item notification-dropdown"
    @show="onDropdownShow"
    @hide="onDropdownHide"
  >
    <NotificationsToggle
      :expanded="isDropdownVisible"
      controls-id="notification-center-list"
    />
    <NotificationsList ref="notificationsList" />
  </CDropdown>
</template>
<script>
import NotificationsToggle from "./Notifications/layout/NotificationsToggle.vue"
import NotificationsList from "./Notifications/layout/NotificationsList.vue"
import { ref } from "vue"

export default {
  name: "TheHeaderDropdownNotif",
  components: { NotificationsToggle, NotificationsList },
  setup() {
    const notificationsList = ref(null)
    const isDropdownVisible = ref(false)

    const markNotificationsAsSeen = () => {
      notificationsList.value?.markNotificationsAsSeen?.()
    }
    const onDropdownShow = () => {
      isDropdownVisible.value = true
    }
    const onDropdownHide = () => {
      isDropdownVisible.value = false
      markNotificationsAsSeen()
    }

    return {
      notificationsList,
      isDropdownVisible,
      onDropdownShow,
      onDropdownHide
    }
  }
}
</script>
